const transform = require('lodash/transform');
const cloneDeep = require('lodash/cloneDeep');
const extend = require('lodash/extend');

function mapPropertiesToMutateObject(properties, globalProperties = {}) {
  const newProperties = extend(cloneDeep(globalProperties), properties);

  return transform(newProperties, (result, value, key)  => {
    if (typeof value !== 'undefined') {
      result[key] = {$set: value};
    }
    return result;
  }, {});
}

module.exports = mapPropertiesToMutateObject